import {CountryModel} from '../../../modules/common/localization/country/api/entity/country.model';


export class AccountSummary {
    id: number;
    businessCode: string;
    name: string;
    country: CountryModel;
    themeName: string;
    email: string;

}
